import { ExportPdfButtonIcon } from '@/Components/Common/Icons';
import PropTypes from 'prop-types';

const ExportPdfButton = ({ onClick, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <ExportPdfButtonIcon />
    </button>
  );
};

ExportPdfButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ExportPdfButton;
